// extracted by mini-css-extract-plugin
export default {"modifyDialog":"ModifyDialog_modifyDialog__C6uMm","yes":"ModifyDialog_yes__TXoMX","no":"ModifyDialog_no__XCg6-"};